import { useAppDispatch, useAppSelector } from "../../Redux/store";
import { setCodeSrc } from "../../Redux/developerSlice";
import { Button } from "../Common/Button";
import { LiveEditor } from "./LiveEditor";
import { useEffect, useState } from "react";
import { ModalType, setModal } from "../../Redux/uiSlice";
import { BytesDisplay } from "../BytesDisplay";
import { useLocalStorage } from "../../hooks/localStorage";
import { postScreenSizeMessage } from "../../hooks/screenSize";

export const DeveloperModeUI = () => {
    const dispatch = useAppDispatch();
    const [loadedData, setLoadedData] = useState<string>('');
    const { codeSrc } = useAppSelector(state => state.developerSandbox)
    const localStorage = useLocalStorage();

    useEffect(() => {
        const data = localStorage.getItem('wowboi-code');
        if (data) setLoadedData(data);
    }, [])

    const onSave = () => {
        localStorage.setItem('wowboi-code', encodeURIComponent(codeSrc));
        setLoadedData(encodeURIComponent(codeSrc));
    };

    const onLoad = () => {
        if (loadedData) {
            dispatch(setCodeSrc(decodeURIComponent(loadedData)));
            postScreenSizeMessage()
        }
    };

    const onInscribe = () => dispatch(setModal(ModalType.INSCRIBE));

    return (
        <div className="flex lg:w-full items-center justify-center gap-y-20 relative w-max-56vw h-[calc(100%-48px)]">
            <div id="codemirror-container" className="flex flex-col h-full w-full overflow-auto relative">
                <div className="flex gap-4 mt-3 mb-4" key={JSON.stringify(loadedData)}>
                    <Button
                        text="Save"
                        onClick={onSave}
                        alertMessage="Saved!"
                        className="min-w-100, p-4 text-sm bg-white h-12"
                    />
                    <Button
                        text="Load"
                        onClick={onLoad}
                        alertMessage="Loaded!"
                        className="min-w-110 p-4 text-sm bg-white h-12"
                        key={JSON.stringify(loadedData)}
                        disabled={Boolean(!loadedData)}
                    />
                    <Button text="Inscribe" onClick={onInscribe} className="min-w-120 p-4 text-sm bg-white h-12" />
                    <div className="items-end ml-auto flex">
                        <a
                            href="https://wowboi.notion.site/WowBoi-Developer-Guide-a5de706805bf484dbd27a1620d1451d1?pvs=4"
                            target='_blank'
                        >
                            <p className="interactions-text text-sm underline">
                                WowBoi Docs
                            </p>
                        </a>
                    </div>
                </div>
                <LiveEditor className="mb-6 min-h-288 w-full box-border overflow-auto box-shadow heavy-border bg-grey" />
                <div className="absolute bottom-0 right-0">
                    <BytesDisplay />
                </div>
            </div>
        </div>
    )
}